module.exports = __webpack_public_path__ + "img/bicara-bumi.f841010c.jpg";